import { render } from "./ShopAlipayDMF.vue?vue&type=template&id=675bd83e&scoped=true"
import script from "./ShopAlipayDMF.vue?vue&type=script&lang=js"
export * from "./ShopAlipayDMF.vue?vue&type=script&lang=js"

import "./ShopAlipayDMF.vue?vue&type=style&index=0&id=675bd83e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675bd83e"]])

export default __exports__